import {
  UCCFailure,
  UCCLookUpParams,
  UCCLookUpProvider,
  UCCLookupTypes,
  UCCOperParams,
  UCCOperProvider,
  UCCOperTypes,
  UCCViewParams,
  UCCViewProvider,
  UCCViewTypes,
} from '.'
import { Result, failure, success } from '../shared'

export class UCCService {
  constructor(
    private readonly lookupProvider: UCCLookUpProvider,
    private readonly viewProvider: UCCViewProvider,
    private readonly operProvider: UCCOperProvider,
  ) {}

  public async oper(action: UCCOperTypes, params: Partial<UCCOperParams>): Promise<Result<any, UCCFailure>> {
    try {
      const { data } = await this.operProvider.oper(action, params)
      return success(data)
    } catch (error) {
      const code = error.Code
      return failure(code, {
        code,
        message: error.Message || error.Text,
      })
    }
  }

  public async view(action: UCCViewTypes, params: Partial<UCCViewParams>): Promise<Result<any, UCCFailure>> {
    try {
      const { data } = await this.viewProvider.view(action, params)
      return success(data)
    } catch (error) {
      const code = error.Code
      return failure(code, {
        code,
        message: error.Message || error.Text,
      })
    }
  }

  public async lookup(action: UCCLookupTypes, params: UCCLookUpParams): Promise<Result<any, UCCFailure>> {
    try {
      const { data } = await this.lookupProvider.lookup(action, params)
      return success(data)
    } catch (error) {
      const code = error.Code
      return failure(code, {
        code,
        message: error.Message || error.Text,
      })
    }
  }
}
